/* ═══════════════════════════════════════════════════════════
   ATLANTIC NATURALS — Homepage Scroll Reveal Engine
   IntersectionObserver-based scroll animations
   ═══════════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', function() {
  // Only run on the homepage
  if (document.body.classList.contains('template-index') || window.location.pathname === '/') {

    /* ─── Scroll Reveal Observer ─── */
    (function() {
      var revealTargets = [
        // Shopify section wrappers (use ID selectors for sections)
        '[id*="featured_collection"]',
        '.an-quiz-cta',
        '.health-benefits',
        '.section-collection-list',
        '.an-featured',
        '.an-stats',
        '.an-why',
        '.customer-review',
        '.an-ugc',
        // Generic reveal classes
        '.an-hp-reveal',
        '.an-hp-reveal-left',
        '.an-hp-reveal-right',
        '.an-hp-reveal-scale'
      ];

      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('an-hp-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      revealTargets.forEach(function(selector) {
        document.querySelectorAll(selector).forEach(function(el) {
          // Mark element as JS-ready so CSS can safely hide it for animation
          el.classList.add('an-hp-ready');
          observer.observe(el);
        });
      });
    })();

    /* ─── Animated Counters — Stats Banner ─── */
    (function() {
      var counted = false;
      var counterObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting && !counted) {
            counted = true;
            animateCounters();
            counterObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.25 });

      var statsSection = document.querySelector('.an-stats');
      if (statsSection) counterObserver.observe(statsSection);

      function animateCounters() {
        document.querySelectorAll('.an-stats__num').forEach(function(el) {
          var text = el.textContent.trim();
          var match = text.match(/^([\d,.]+)/);
          if (!match) return;

          var target = parseFloat(match[1].replace(/,/g, ''));
          var suffix = text.replace(match[1], '');
          var isDecimal = match[1].indexOf('.') > -1;
          var duration = 1800;
          var startTime = null;

          function step(timestamp) {
            if (!startTime) startTime = timestamp;
            var progress = Math.min((timestamp - startTime) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            var current = eased * target;

            if (isDecimal) {
              el.textContent = current.toFixed(1) + suffix;
            } else if (target >= 1000) {
              el.textContent = Math.floor(current).toLocaleString() + suffix;
            } else {
              el.textContent = Math.floor(current) + suffix;
            }

            if (progress < 1) {
              requestAnimationFrame(step);
            } else {
              el.textContent = text;
            }
          }
          requestAnimationFrame(step);
        });
      }
    })();

  }
});
